import React from 'react'
import { useState, useEffect } from 'react';
import '../viewFiles/common.scss';
import axios from 'axios';
import urls from '../../utils/url';
import {  isJson, getReadableDateOnly, getReadableTimeOnly , getReadableTime} from '../../utils/converter';
import Loading from '../common/loading';
import Reload from '../common/Reload';
import Cookie from 'js-cookie';
import NoData from '../common/NoData';
import '../navam/navamViewFile.scss';
import { Select } from '@mui/material';
import {MenuItem,FormControl,InputLabel,Box,ListItemText, Menu} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import VitalTable from './vitalTable';
import { LocalConvenienceStoreOutlined } from '@mui/icons-material';


const NavamNewbornVitals  = (props) => {

    const cookie = Cookie.get('access_token')
    const { patientID } = props;
    const [ loading, setLoading ] = useState(false)
    const [ error, setError ] = useState(false);
    const [ dateList, setDateList] = useState([]);
    const [ vitalData, setVitalData] = useState() 
    const [ babyAge, setBabyAge] = useState(); // in months

    const [selectedTimeOption, setSelectedTimeOption] = useState("15 mins");
    const [anchorEl, setAnchorEl] = useState(null);

    const [selectedDate, setSelectedDate] = useState(''); 
    const [isUserSelected, setIsUserSelected] = useState(false); // Track if the user has made a selection
    const [selectedData, setSelectedData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (vitalData && selectedDate) {
      const selected_vital_data = vitalData.filter(item => item.data_time === selectedDate);
      setSelectedData(selected_vital_data);
    }
  }, [vitalData, selectedDate]);

    useEffect(() => {
      if (Array.isArray(vitalData) && vitalData.length > 0) {
        setSelectedDate(vitalData[0].data_time);
      }
    }, [vitalData]);
  

    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
      setIsUserSelected(true); // Update that user has made a selection
    };

    const timeDifferenceMap = {
      "15 mins": 15,
      "30 mins": 30,
      "45 mins": 45,
      "1 hr": 60,
      "2 hr": 120,
      "3 hr": 180
    };

    const getVitalRange = (ageInMonths) => {
      switch (true) {
        case ageInMonths <= 12: 
          return { rr: [25, 60], hr: [110, 180], spo2:[90,100], pulse:[110,180]};
        case ageInMonths >= 13 && ageInMonths <= 24:
          return { rr: [20, 50], hr: [100, 170], spo2:[92,100], pulse:[100,170]};
        case ageInMonths >= 25 && ageInMonths <= 59: 
          return { rr: [18, 40], hr: [90, 160], spo2:[92,100], pulse:[90,160]};
        case ageInMonths >= 60 && ageInMonths <= 119:
          return { rr: [17, 30], hr: [70, 140], spo2:[92,100], pulse:[70,140]};
        case  ageInMonths >= 120 && ageInMonths <= 179: 
          return { rr: [14, 25], hr: [60, 120], spo2:[92,100], pulse:[60,120]};
        case ageInMonths >=180: 
          return { rr: [12, 18], hr: [60, 100], spo2:[94,100], pulse:[60,100]};
      }
    };


    const vitalByTimeDifference = (data, timeDifferenceInMinutes) => {

      //console.log(data)

      const vitalRange = getVitalRange(babyAge);
      
      //console.log(vitalRange)

      let dataTime = data && data.length > 0 ? data.map(value => value.data_time).join(", ") : "";
    
      let vitalParam = data && data.length > 0 ? data.map(value => value.params) : [];
  
      let previousTimestamp = null;    
      const itemFilter = vitalParam && vitalParam.length > 0 ? vitalParam.map((value, index) => {
          const processedData = Object.entries(value).reduce((acc, [paramType, dataArray]) => {
            if (!Array.isArray(dataArray)) {
              acc[paramType] = [];
              return acc;
            }
    
            // We will collect all out-of-range timestamps first
            const outOfRangeTimestamps = new Set();
    
            // First pass: detect out-of-range timestamps across all params
            Object.entries(value).forEach(([key, arr]) => {
              if (!Array.isArray(arr)) return;
    
              arr.forEach((obj) => {
                Object.entries(obj).forEach(([timestampStr, val]) => {
                  const timestamp = Number(timestampStr);
                  const value = parseFloat(val);
    
                  let range = [];
                  if (key === "pulse") range = vitalRange.pulse;
                  if (key === "rr") range = vitalRange.rr;
                  if (key === "spo2") range = vitalRange.spo2;
                  if (key === "hr") range = vitalRange.hr;
    
                  const [min, max] = range;
                  if (!isNaN(value) && (value < min || value > max)) {
                    outOfRangeTimestamps.add(timestamp);
                  }
                });
              });
            });
    
            // Second pass: filter values based on timestamps in the outOfRangeTimestamps set
            const filteredData = dataArray
              .filter(object => typeof object === "object" && object !== null)
              .map(object => {
                const timestamps = Object.keys(object).map(Number).filter(num => !isNaN(num)).sort((a, b) => a - b);
                let result = {};
    
                for (let timestamp of timestamps) {
                  if (outOfRangeTimestamps.has(timestamp)) {
                    result[timestamp] = object[timestamp];
                  }
                }
    
                return result;
              });
    
            acc[paramType] = filteredData;
            return acc;
          }, {});
    
          return processedData;
        }) 
      : [];
    
    
      return {
        data_time: dataTime,
        params: itemFilter, 
      };
    };
    
    const getAgeInMonths = (dobString) => {
      const dob = new Date(dobString); // Parse DOB
      const today = new Date(); // Current date
  
      let months = (today.getFullYear() - dob.getFullYear()) * 12;
      months += today.getMonth() - dob.getMonth();
  
      if (today.getDate() < dob.getDate()) {
          months--; // Adjust if the day in the current month hasn't passed yet
      }
  
      return months;
    }

    const mergeByMonitoringSessionId = (data) => {
      const sessionMap = new Map();
    
      data.forEach(entry => {
        const sessionId = entry.monitoring_session_id;
    
        if (!sessionMap.has(sessionId)) {
          // Clone and ensure data_set is a proper object
          const clonedEntry = JSON.parse(JSON.stringify(entry));
          clonedEntry.params = clonedEntry.params.map(p => ({
            ...p,
            data_set: typeof p.data_set === 'object' && !Array.isArray(p.data_set)
              ? { ...p.data_set }
              : Object.assign({}, ...(p.data_set || []))
          }));
          sessionMap.set(sessionId, clonedEntry);
        } else {
          const existing = sessionMap.get(sessionId);
    
          // Use the earliest data_time
          existing.data_time = Math.min(existing.data_time, entry.data_time);
    
          const paramMap = {};
    
          // Map existing params
          existing.params.forEach(p => {
            paramMap[p.param_type] = {
              ...p,
              data_set: { ...(p.data_set || {}) }
            };
          });
    
          // Merge incoming params
          entry.params.forEach(p => {
            const incomingDataSet = typeof p.data_set === 'object' && !Array.isArray(p.data_set)
              ? { ...p.data_set }
              : Object.assign({}, ...(p.data_set || []));
    
            if (paramMap[p.param_type]) {
              Object.assign(paramMap[p.param_type].data_set, incomingDataSet);
            } else {
              paramMap[p.param_type] = {
                ...p,
                data_set: incomingDataSet
              };
            }
          });
    
          existing.params = Object.values(paramMap);
        }
      });
    
      return Array.from(sessionMap.values());
    };
    
    
    useEffect(() => {
      setLoading(true);
      axios.get(`${urls. BETA_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=keyar_data,basic_detail&`,
        {
          headers: {
          'Request-ID': 'allow|me', 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookie}`
        }
        }).then((res) => {
          if(res.data){
            const json_data = isJson(res.data)
            const baby_age = json_data.response[0]?.basic_detail?.dob;
            
            setBabyAge(getAgeInMonths(baby_age));
            
            const keyar_data =  json_data.response[0]?.keyar_data || [];
         
            const filteredParamKeyarData = keyar_data && keyar_data.length > 0 ? keyar_data.filter(item => Array.isArray(item.params) && item.params.length > 0) : [];

            const mergedByMonitoringSessionId = mergeByMonitoringSessionId(filteredParamKeyarData)

        
            const sortedKeyarData = mergedByMonitoringSessionId && mergedByMonitoringSessionId.length > 0 ? mergedByMonitoringSessionId.sort((a, b) => (a.data_time < b.data_time) ? 1 : -1) : [];
           
            const filteredArrayWithParams = sortedKeyarData.map(item => {

              const spo2Param = item.params?.filter(item => item.param_type === 'spo2').map(item => item.data_set);
              const rrParam = item.params?.filter(item => item.param_type === 'rr').map(item => item.data_set);
              const tempParam = item.params?.filter(item => item.param_type === 'temp').map(item => item.data_set);
              const hrvParam = item.params?.filter(item => item.param_type === 'hrv').map(item => item.data_set);
              const pulseParam = item.params?.filter(item => item.param_type === 'pulse').map(item => item.data_set);
              const heartHeartParam = item.params?.filter(item => item.param_type === 'hr').map(item => item.data_set);
              
              return {
                data_time: item.data_time,
                params: {
                  spo2: spo2Param,
                  rr: rrParam,
                  temp: tempParam,
                  hrv: hrvParam,
                  pulse: pulseParam,
                  hr: heartHeartParam,
                }
              };
            });
                
            setVitalData(filteredArrayWithParams)
            setLoading(false) 
            
          }
        }).catch((err) => {
          console.log("Error in Fetching Data",err)
          setError(true)
          setVitalData([])
          setLoading(false)
        }
      )
    },[])

    const handleImageClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const handleMenuItemClick = (label) => {
      setSelectedTimeOption(label);
      handleClose(); 
    };

    useEffect(() => {
      const timeDifferenceInMinutes = timeDifferenceMap[selectedTimeOption];
      const filteredVitalByTimeDifference = vitalByTimeDifference(selectedData, timeDifferenceInMinutes);
      setFilteredData(filteredVitalByTimeDifference)
    }, [selectedTimeOption, selectedData])



  return (
    
      <>
        
        <Box sx={{display: "flex",flexDirection: "column",alignItems: "flex-end", fontFamily: 'Poppins', marginRight:`6rem`}} >
          <FormControl 
            sx={{
              minWidth: "11rem",
              "& .MuiOutlinedInput-root": { borderRadius: "8px", border:"0.5px solid #A163F1",
                "&.Mui-focused": {borderColor: "#A163F1"},
              }
            }}
          >

            {isUserSelected && (
              <InputLabel
                sx={{color:'#000000', fontFamily:'Poppins', fontSize:'1rem', transition: "all 1s ease-in-out", 
                    '&.Mui-focused': {color: '#000000'},
                   }}
              >
                Date
              </InputLabel>
            )}

            <Select value={selectedDate} onChange={handleDateChange} displayEmpty
                renderValue={(selected) =>
                  !isUserSelected ? "Date" : getReadableTime(selected)
                }
                sx={{borderRadius: '8px',height: '2.5rem',background: '#FFFFFF !important',fontFamily: 'Poppins', marginTop:'0.5rem',
                    "& .MuiSelect-icon": {
                      color: "black", 
                    },
                    '&:hover': { border: '0.5px solid #A163F1' },
                    '& .MuiSelect-select': {fontSize: '1rem',fontWeight: '400',},
                    '& .MuiOutlinedInput-notchedOutline': {border: 'none'},
                  }}
                MenuProps={{
                  PaperProps: {
                    style: {marginTop: '0.2rem', backgroundColor: '#faf6ff !important'},
                  },
                }}
            >
              {vitalData && vitalData.length > 0 && vitalData.map((value, index) => (
                <MenuItem key={index} value={value.data_time}
                  sx={{ fontFamily: "Poppins, sans-serif",fontSize: '1rem',display: 'flex', justifyContent: 'space-between',alignItems: 'center',
                      '&:hover': {backgroundColor: '#faf6ff !important', fontFamily: 'Poppins'},
                      '&.Mui-selected': {backgroundColor: '#faf6ff !important',marginTop:'0.5rem',fontFamily: 'Poppins' },
                    }}
                >
                    <ListItemText primary={getReadableTime(value.data_time)}
                        primaryTypographyProps={{
                          style: {fontFamily: "Poppins"},
                        }}
                    />

                    {value.data_time ===  selectedDate && (
                      <CheckIcon sx={{ color: "#6BBF59", width:'1.5rem', height:'1.5rem'}} />
                    )}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <div className='info-section'>
           
            <div className = 'info-header navam-vital-header'>
                <p className = 'heading'>Vitals Table</p>
                <img src='/time-clock.svg' Alt = 'Time Change Icon' width={25} height={25} 
                  style={{paddingRight:`5rem`, cursor: "pointer",borderRadius: "8px",}} onClick={handleImageClick}/>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}
                    PaperProps={{
                      style: { marginTop: '0.5rem', backgroundColor: '#faf6ff', borderRadius: '8px', },
                    }}>

                    {Object.keys(timeDifferenceMap).map((label) => (
                        <MenuItem key={label} onClick={() => handleMenuItemClick(label)}
                          sx={{fontFamily: "Poppins, sans-serif",fontSize: '1rem',display: 'flex',justifyContent: 'space-between',alignItems: 'center',
                            '&:hover': {
                              backgroundColor: '#f0e8ff',
                            },
                            '&.Mui-selected': {
                              backgroundColor: '#faf6ff',
                            },
                          }}
                        >
                          <ListItemText primary={label} primaryTypographyProps={{
                              style: { fontFamily: "Poppins" },
                            }}
                          />
                          {label === selectedTimeOption && (
                            <CheckIcon sx={{ color: "#6BBF59", width: '1.2rem', height: '1.2rem', paddingLeft:`0.5rem` }} />
                          )}
                        </MenuItem>
                    ))}
                  </Menu>
            </div>
                
            <>
              {loading ? 
                (
                  <div className='loading-div'><Loading /></div>
                ) 
              : error ? 
                (
                  <div className='reload-div'><Reload /></div>
                ) 
              : vitalData && vitalData.length >  0 ? 
                (
                  <VitalTable selectedDate={selectedDate} data={filteredData.params} babyAge= {babyAge}/>
                ) 
              : 
              (
                <NoData />
              )}
            </>
        </div>
      </>
  )
}

export default NavamNewbornVitals  

